export default __webpack_public_path__ + "static/judges_for_issf-0f3d4f7dad09df947632111552d4e8aa.jpg";